import {
    buildActionCreators,
    makeActionTypes,
    makeAsyncEvents,
    singleParameter,
} from '../../common/helpers/ReduxHelpers';

import { DOMAIN } from './Reporting.constants';

export const events = {
    setFilters: singleParameter,
};

export const asyncEvents = makeAsyncEvents(['update'], true);

export const types = makeActionTypes([...Object.keys(events), ...Object.keys(asyncEvents)], DOMAIN);

export default buildActionCreators(
    {
        ...events,
        ...asyncEvents,
    },
    types
);
